import React from 'react'
import { Link } from "react-router-dom";
import { Search } from './Search';

// npm i react-router-dom react-player react-loader-spinner use-debounce 
// installing dependencies 

export const Navbar = ({darkTheme,setDarkTheme}) => {
    return (
        <div className="p-5 pb-0 flex flex-wrap sm:justify-between justify-center items-center border-b dark:border-gray-700 border-gray-200">
            <div className="flex justify-between items-center space-x-5 w-screen">
            <Link to="/">
            <p className="text-2-xl bg-blue-500 rounded-full font-bold py-1 px-2 text-white dark:text-gray-900 dark:bg-gray-500">
                SabzSearch 🔎
            </p>
            </Link>

            <button type="button" onClick={
                ()=> setDarkTheme(!darkTheme)
                } className="text-xl dark:bg-gray-50 dark:text-gray-900 bg-white border hover:shadow-lg rounded-full px-2 py-1 mb-3">
                {darkTheme? 'Light 🔅': 'Dark 🌙' }

            </button>
            </div>
            <Search/>
        </div>
    )
}
